import FeatureFlagRecord from "models/view-models/feature-flag-record";
import ServiceFactory from "../service-factory";

interface QueryParams {}

interface UpdateFeatureFlagPathParams {
    name: string;
}

interface UpdateFeatureFlagBody {
    isEnabled: boolean;
}

const baseEndpoint = "feature-flags";
const updateEndpoint = `${baseEndpoint}/:name`;

const resourceType = FeatureFlagRecord;

const FeatureFlagsService = {
    list: ServiceFactory.list<FeatureFlagRecord, QueryParams>(
        resourceType,
        baseEndpoint
    ),
    update: ServiceFactory.patch<
        FeatureFlagRecord,
        UpdateFeatureFlagPathParams,
        UpdateFeatureFlagBody
    >(resourceType, updateEndpoint),
};

export default FeatureFlagsService;
